export default function handleHistoryChange() {
  window.onpopstate = event => {
    if (event.state.path) {
      Turbo.visit(event.state.path, { action: 'replace' });
    }
  };
}
